import { useContext } from "react";
import GlobalsContext from "../context/GlobalsContext";

export default function () {
  return useContext(GlobalsContext);
}
